module.exports = __webpack_public_path__ + "static/media/exclamation.c120e17c.svg";